export const STAGE_NEW_ROUND = "STAGE_NEW_ROUND";
export const STAGE_PREFLOP = "STAGE_PREFLOP";
export const STAGE_FLOP = "STAGE_FLOP";
export const STAGE_TURN = "STAGE_TURN";
export const STAGE_RIVER = "STAGE_RIVER";
export const STAGE_RESULT = "STAGE_RESULT";

export const ADD_PLAYER = "ADD_PLAYER";
export const REMOVE_PLAYER = "REMOVE_PLAYER";
export const REMOVE_PLAYERS = "REMOVE_PLAYERS";
export const CHANGE_NAME = "CHANGE_NAME";
export const CHECK_NAME = "CHECK_NAME";
export const GIVE_POINTS = "GIVE_POINTS";

export const MOVE_STAGE = "MOVE_STAGE";
export const SET_STAGE = "SET_STAGE";
export const START_GAME = "START_GAME";
export const END_GAME = "END_GAME";

export const TOGGLE_AUTOPLAY = "TOGGLE_AUTOPLAY";
export const TURN_AUTOPLAY_ON = "TURN_AUTOPLAY_ON";
export const TURN_AUTOPLAY_OFF = "TURN_AUTOPLAY_OFF";

export const REFRESH_DEALER = "REFRESH_DEALER";
export const DEAL_PLAYER = "DEAL_PLAYER";
export const DEAL_TABLE = "DEAL_TABLE";

export const HIGHLIGHT = "HIGHLIGHT";

export const ADD_LOG = "ADD_LOG";
export const CLEAR_LOGS = "CLEAR_LOGS";
